import { render, staticRenderFns } from "./followupplan.vue?vue&type=template&id=039d8593&"
import script from "./followupplan.vue?vue&type=script&lang=js&"
export * from "./followupplan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports